import React from "react";
import PropTypes from "prop-types";
import Checkbox from "@components/Ui/Checkbox";
import TextInputLabel from "@components/Ui/TextInputLabel";
import "./style.scss";

const VoucherGifts = ({ giftData, onGiftDataChange, errorMessages = {} }) => {
    const { recipientName, recipientEmail, giftMessage, leaveMessageBlank } = giftData;

    const handleFieldChange = (field) => (e) => {
        onGiftDataChange({ ...giftData, [field]: e.target.value });
    };

    const handleLeaveMessageBlankChange = () => {
        const newValue = !leaveMessageBlank;
        onGiftDataChange({
            ...giftData,
            leaveMessageBlank: newValue,
            giftMessage: newValue ? "" : giftMessage,
        });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <div className="gifting__wrapper">
            <form className="gifting__form" onSubmit={handleFormSubmit}>
                <div className="gifting__field-wrapper">
                    <TextInputLabel
                        id="RecipientName"
                        name="RecipientName"
                        labelName="Recipient Name *"
                        required={true}
                        value={recipientName}
                        onChange={handleFieldChange("recipientName")}
                        isValueErrored={errorMessages.recipientName != null}
                        placeholder="Enter recipient name"
                    />
                    {errorMessages.recipientName && (
                        <span id="recipientName-error" className="gifting__error" role="alert">
                            {errorMessages.recipientName}
                        </span>
                    )}
                </div>

                <div className="gifting__field-wrapper">
                    <TextInputLabel
                        id="RecipientEmail"
                        name="RecipientEmail"
                        required={true}
                        labelName="Enter recipient email address *"
                        value={recipientEmail}
                        onChange={handleFieldChange("recipientEmail")}
                        isValueErrored={errorMessages.recipientEmail != null}
                        placeholder="recipient@example.com"
                        type="email"
                    />
                    {errorMessages.recipientEmail && (
                        <span id="recipientEmail-error" className="gifting__error" role="alert">
                            {errorMessages.recipientEmail}
                        </span>
                    )}
                </div>

                <div className="gifting__group">
                    <label className="gifting__textarea-label" htmlFor="GiftMessage">
                        Recipient message (optional)
                    </label>
                    <Checkbox
                        id="gift-message"
                        buttonAlignment="right"
                        checked={leaveMessageBlank}
                        onChange={handleLeaveMessageBlankChange}
                    >
                        I would like it to be left blank
                    </Checkbox>
                </div>

                <div className="gifting__field-wrapper">
                    <textarea
                        id="GiftMessage"
                        name="GiftMessage"
                        className="gifting__textarea"
                        value={giftMessage}
                        onChange={handleFieldChange("giftMessage")}
                        placeholder="Share a personal message"
                        rows={4}
                        disabled={leaveMessageBlank}
                    />
                </div>
            </form>
        </div>
    );
};

VoucherGifts.propTypes = {
    giftData: PropTypes.shape({
        recipientName: PropTypes.string.isRequired,
        recipientEmail: PropTypes.string.isRequired,
        giftMessage: PropTypes.string.isRequired,
        leaveMessageBlank: PropTypes.bool.isRequired,
    }).isRequired,
    onGiftDataChange: PropTypes.func.isRequired,
    errorMessages: PropTypes.shape({
        recipientName: PropTypes.string,
        recipientEmail: PropTypes.string,
    }),
};

export default VoucherGifts;
